import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { SOLUTIONS } from "@/data/solutions";
import { Button } from "@/components/ui/button";
import PortfolioModal from "@/components/PortfolioModal";

export default function SolutionsGrid() {
  return (
    <section id="solucoes" className="scroll-mt-nav bg-efory-ink text-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <div className="max-w-3xl">
          <span className="inline-block rounded-full border border-efory-blue/30 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.2em] text-efory-blue">
            Soluções EFORY
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight mt-6 leading-[1.1]">
            Imagine sua empresa e{" "}
            <span className="text-efory-blue">deixe o resto com a gente</span>
          </h2>
          <p className="mt-5 text-base sm:text-lg text-white/65 leading-relaxed">
            Conheça as 10 soluções que conectam marketing, vendas, CRM, conteúdo e gestão para{" "}
            <span className="text-white font-semibold">acelerar o crescimento</span> do seu
            negócio.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {SOLUTIONS.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.id}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: (i % 4) * 0.08 }}
                data-testid={`solution-card-${s.id}`}
                className="group rounded-2xl border border-white/10 bg-white/[0.03] p-6 md:p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-black/40 hover:border-efory-blue/40 hover:bg-white/[0.05]"
              >
                <div className="h-12 w-12 rounded-xl bg-efory-blue/10 flex items-center justify-center text-efory-blue transition-colors duration-300 group-hover:bg-efory-blue group-hover:text-white">
                  <Icon className="h-6 w-6" strokeWidth={2} />
                </div>
                <h3 className="font-heading text-lg font-bold mt-5 leading-tight">{s.title}</h3>
                <p className="text-sm text-white/60 mt-2 leading-relaxed">{s.short}</p>
                {s.portfolio ? (
                  <PortfolioModal type={s.portfolio} />
                ) : (
                  <a
                    href="#solucoes-detalhes"
                    data-testid={`solution-more-${s.id}`}
                    className="inline-flex items-center gap-1.5 text-sm font-semibold text-efory-blue mt-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                  >
                    Saiba mais <ArrowRight className="h-4 w-4" />
                  </a>
                )}
              </motion.div>
            );
          })}
        </div>

        <div className="mt-12 flex justify-center">
          <a href="#solucoes-detalhes">
            <Button
              size="lg"
              data-testid="explore-all-solutions-button"
              className="group bg-efory-blue hover:bg-efory-bluedark text-white rounded-full px-8 py-6 text-base font-semibold transition-all duration-300 hover:scale-[1.03] shadow-lg shadow-efory-blue/20"
            >
              Conhecer todas as soluções a fundo
              <ArrowRight className="ml-2 h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
}
